export default __webpack_public_path__ + "static/media/5.4a749242.JPG";